// 接口配置（所有接口地址放在这里，统一管理）
export default {

    getRecommendPackageByFeatureCodes : '/spiderEcm/spider/xpAction/getRecommendPackageByFeatureCodes.do',
    getMultiSfilterRecordList1 : '/record2mongo/Record2MongoApi/getMultiSfilterRecordList1',
    getCommercialPackageByFeatureCodes: '/spiderEcm/spider/xpAction/getCommercialPackageByFeatureCodes.do',

};